"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Key = void 0;
exports.Key = { create, parse, toString, step, up, compare, depth };
function create(key, x = 0, y = 0, z = 0) {
    if (typeof key !== 'number')
        return parse(key);
    return [key, x, y, z];
}
function parse(s) {
    if (typeof s !== 'string')
        return s;
    const [d, x, y, z, ...rest] = s.split('-').map((s) => parseInt(s, 10));
    const key = [d, x, y, z];
    if (rest.length !== 0 ||
        key.some((v) => typeof v !== 'number' || Number.isNaN(v))) {
        throw new Error(`Invalid key: ${s}`);
    }
    return key;
}
function toString(key) {
    if (typeof key === 'string')
        return key;
    return key.join('-');
}
function step(key, [a, b, c]) {
    const [d, x, y, z] = exports.Key.create(key);
    return [d + 1, x * 2 + a, y * 2 + b, z * 2 + c];
}
function up(key, n = 1) {
    const [d, x, y, z] = exports.Key.create(key);
    return [d - n, x >> n, y >> n, z >> n];
}
function compare(a, b) {
    for (let i = 0; i < a.length; ++i) {
        if (a[i] < b[i])
            return -1;
        if (a[i] > b[i])
            return 1;
    }
    return 0;
}
function depth(key) {
    return key[0];
}
